export default (dc, { defaultModel, defaultView, ...config }) => {
  const type = 'slider-dots'
  const attrKey = config.attrSliderDots
  const classKey = config.classSliderDots

  dc.addType(type, {
    model: defaultModel.extend({
      defaults: {
        ...defaultModel.prototype.defaults,
        name: 'Slider Dots',
        draggable: false,
        droppable: false,
        copyable: false,
        removable: false,
        ...config.sliderDotsProps
      },

      init() {
        const attrs = this.getAttributes()
        attrs[attrKey] = 1
        this.setAttributes(attrs)
        classKey && this.addClass(classKey)
      }
    }, {
      isComponent(el) {
        if (el.hasAttribute && el.hasAttribute(attrKey)) {
          return { type }
        }
      }
    }),
    view: defaultView
  })
}
